import React from 'react'
import PropTypes from 'prop-types'

import BarStackedCartesian from '_components/audience-insights/charts/bar-stacked-cartesian'
import useRect from '../hooks/useRect'

function BarStackedCartesianHOC({ data, colors, mode, labels }) {
  const [Rect, rect] = useRect()

  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="render-bar-stacked-cartesian-chart"
        data-json={JSON.stringify(data)}
        data-mode={JSON.stringify(mode)}
        data-colors={JSON.stringify(colors)}
        data-labels={JSON.stringify(labels)}
      >
        <BarStackedCartesian
          data={data}
          width={rect.width}
          height={rect.height}
          colors={colors}
          mode={mode}
          labels={labels}
        />
      </foreignObject>
    </>
  )
}

BarStackedCartesianHOC.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  labels: PropTypes.shape({
    x: PropTypes.string.isRequired,
    y: PropTypes.string.isRequired,
  }).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
  mode: PropTypes.oneOf(['single', 'stacked']),
}

BarStackedCartesianHOC.defaultProps = {
  colors: [],
  mode: 'single',
}

export default BarStackedCartesianHOC
